import '@wpmudev/shared-ui';

console.log('This is the entry point.');



// WEBPACK FOOTER //
// ./_src/js/index.js